<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="copyright-page">
<p class="copyt1"><span epub:type="pagebreak" id="page_iv" title="iv">Copyright © 1971 by Charles Willeford</span></p>
<p class="copyt">Cover © 2020 Abrams</p>
<p class="copyt">Published in 2020 by The Overlook Press, an imprint of ABRAMS. All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without written permission from the publisher.</p>
<p class="copyt">Library of Congress Control Number: 2019938599</p>
<p class="copyt">ISBN: 978-1-4197-4045-9<br/>eISBN: 978-1-68335-801-5</p>
<p class="copyt">Abrams books are available at special discounts when purchased in quantity for premiums and promotions as well as fundraising or educational use.<br/>Special editions can also be created to specification. For details, contact specialsales@abramsbooks.com or the address below.</p>
<p class="copyt"><img alt="Images" src="images/copya.jpg"/><br/><strong>ABRAMS</strong> The Art of Books<br/>195 Broadway, New York, NY 10007<br/><a href="http://abramsbooks.com" target="_blank">abramsbooks.com</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?2b799c0b